'use client';

import dynamic from 'next/dynamic';

const CheckoutPage = dynamic(() => import('@/components/CheckoutPage'), { ssr: false });

const page = () => {
  return (
    <div id='container'>
      <CheckoutPage />
    </div>
  );
};

export default page;
